<template>
  <div class="pt-2 space-y-4">
    <h2 class="font-semibold text-xl text-on-background">
      {{ t('hub-homepage.upcoming') }}
    </h2>
    <div
      v-if="contents.nodes.length > 0"
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5"
    >
      <ContentCard
        v-for="content in contents.nodes"
        :key="content.id"
        :content="content"
      />
    </div>
    <div v-else class="pt-16 pb-8">
      <all-actions-completed-svg class="mx-auto" />
      <div class="font-semibold text-2xl mt-13 text-center">
        {{ t('hub-homepage.action-completed') }}
      </div>
    </div>
  </div>
  <div class="text-center pb-8">
    <Button
      :label="t('hub-homepage.more')"
      :variant="ButtonVariant.OUTLINED"
      @click="emit('show-all')"
    />
  </div>
</template>
<script setup lang="ts">
import { ContentCard } from '~/pages/_components/content-card';
import { Button, ButtonVariant } from '@exfluential/ui';
import AllActionsCompletedSvg from '@/assets/images/all-actions-completed.svg?component';
import { PaginatedContentsDto } from '~/api/contents';

const emit = defineEmits<{
  'show-all': [];
}>();
const props = defineProps<{ contents: PaginatedContentsDto }>();
const { t } = useI18n();
</script>
